import { api } from "@/api";
import type { ProfileUpdatePayload } from "@/core/types";

export async function updatePatientProfile(data: ProfileUpdatePayload) {
  return api.patientTyped.update_profile({ data });
}
